import script from "./StaffPortalView.vue?vue&type=script&lang=ts&setup=true"
export * from "./StaffPortalView.vue?vue&type=script&lang=ts&setup=true"

import "./StaffPortalView.vue?vue&type=style&index=0&id=96fb6d64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96fb6d64"]])

export default __exports__